import moment from 'moment'

export default class Util {
    
    static completarZerosEsquerda(str, length){
            const resto = length - String(str).length
            return '0'.repeat(resto > 0 ? resto : '0') + str
    }

    static urlExists(chave){
        return 'http://rgfumigacao.com.br/api/pictures/' + chave + '.png'
    }

    static formataData(data){
        return moment(data).format('yyyy-MM-DD')
    }

    static letrasMinusculas(palavra){
        return palavra.toLowerCase()
    }

    static removerEspacosEntrePalavras(data){
        return data.replace(/\s/g, '')
    }


    static testaCPF(strCPF) {
        let soma
        let resto
        let i
        soma = 0
        if (strCPF == "00000000000") return false
        
        for (i=1; i<=9; i++) soma = soma + parseInt(strCPF.substring(i-1, i)) * (11 - i)
        resto = (soma * 10) % 11
        
            if ((resto == 10) || (resto == 11))  resto = 0
            if (resto != parseInt(strCPF.substring(9, 10)) ) return false
        
        soma = 0
        for (i = 1; i <= 10; i++) soma = soma + parseInt(strCPF.substring(i-1, i)) * (12 - i)
        resto = (soma * 10) % 11
        
        if ((resto == 10) || (resto == 11))  resto = 0
        if (resto != parseInt(strCPF.substring(10, 11) ) ) return false
        return true
    }

    static formatarDinheiro(valorInicial) {
        let valor = parseFloat(valorInicial); 
        
        if (isNaN(valor)) {
            valor = 0;
        }

        return Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(valor)
    }
    
}